module.exports = __webpack_public_path__ + "static/media/arrow-down-orange.ff160688.svg";